<template>
    <el-dialog
        class="edit"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="编辑面试"
    >
        <div class="container">
            <el-form
                ref="editForm"
                :rules="rules"
                :model="editForm"
                label-width="110px"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="招聘岗位"
                            size="small"
                            prop="role_id"
                        >
                            <el-select
                                v-model="editForm.role_id"
                                clearable
                                placeholder="请选择招聘岗位"
                                size="small"
                                disabled
                            >
                                <el-option
                                    v-for="item in roleList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="面试时间"
                            size="small"
                            prop="interview_time"
                        >
                            <el-date-picker
                                v-model="editForm.interview_time"
                                type="datetime"
                                placeholder="选择面试时间"
                                value-format="yyyy-MM-dd HH:mm"
                                format="yyyy-MM-dd HH:mm"
                                default-time="10:00:00"
                                :picker-options="pickerOptions"
                                :readonly="special"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="应聘者姓名"
                            size="small"
                            prop="name"
                        >
                            <el-input
                                clearable
                                placeholder="请输入应聘者姓名"
                                maxlength="30"
                                size="small"
                                v-model="editForm.name"
                                :readonly="special"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="应聘者手机号"
                            size="small"
                            prop="phone"
                        >
                            <el-input
                                clearable
                                placeholder="请输入应聘者手机号"
                                maxlength="30"
                                size="small"
                                v-model.number="editForm.phone"
                                :readonly="special"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="面试官"
                            size="small"
                            prop="interviewer"
                        >
                            <el-select
                                v-model="editForm.interviewer"
                                clearable
                                placeholder="请选择面试官"
                                size="small"
                                :disabled="special"
                            >
                                <el-option
                                    v-for="item in staffList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="邮箱"
                            size="small"
                            prop="email"
                        >
                            <el-input
                                clearable
                                placeholder="请输入应聘者邮箱"
                                size="small"
                                v-model="editForm.email"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="简历文件" size="small" prop="file">
                            <fileUpload
                                @fileUploaded="fileChange"
                                :file="file"
                                :limit="1"
                                :handleAnimate="editVisible"
                            ></fileUpload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="special">
                    <el-col :span="24">
                        <el-form-item label="总结" size="small" prop="conclusion">
                            <el-input
                                clearable
                                type="textarea"
                                :autosize="{ minRows: 5 }"
                                placeholder="请输入总结"
                                v-model="editForm.conclusion"
                                size="small"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save" v-if="!special"
                >保存</el-button
            >
            <template v-else>
                <el-button
                    size="small"
                    type="primary"
                    @click="save(5)"
                    >通过</el-button
                >
                <el-button
                    size="small"
                    type="primary"
                    @click="save(10)"
                    >不通过</el-button
                >
            </template>
            <el-button size="small" @click="editVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
import { mapState } from "vuex";
import fileUpload from "@/comon/components/fileUpload.vue";
export default {
    data() {
        return {
            editForm: {
                name: "",
                phone: "",
                interview_time: "",
                role_id: "",
                file: "",
                interviewer: "",
                rec_id: "",
                conclusion: "",
                email: "",
            },
            rules: {
                rec_id: [
                    {
                        required: true,
                        message: "请选择招聘岗位",
                        trigger: "blur",
                    },
                ],
                interview_time: [
                    {
                        required: true,
                        message: "选择面试时间",
                        trigger: "blur",
                    },
                ],
                name: [
                    {
                        required: true,
                        message: "请输入应聘者姓名",
                        trigger: "blur",
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入应聘者手机号",
                        trigger: "blur",
                    },
                    {
                        pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
                        message: "手机号格式有误",
                    },
                ],
                file: [
                    {
                        required: true,
                        message: "请上传简历文件",
                        trigger: "blur",
                    },
                ],
                interviewer: [
                    {
                        required: true,
                        message: "请选择面试官",
                        trigger: "change",
                    },
                ],
                conclusion: [
                    {
                        required: true,
                        message: "请输入总结",
                        trigger: "blur",
                    },
                ],
            },
            staffList: [],
            file: [],
        };
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
        special: Boolean,
    },
    watch: {
        editVisible: {
            handler(newValue) {
                if (newValue) {
                    this.interview();
                    this.getRoleList();
                    this.getStaffSelect();
                }
            },
        },
    },
    methods: {
        /**
         * 保存
         */
        save(status) {
            this.$refs["editForm"].validate((valid) => {
                if (valid) {
                    // 编辑
                    if (!this.special) {
                        oaApi
                            .interview(
                                { ...this.editForm },
                                "put",
                                this.tableItem.id
                            )
                            .then((res) => {
                                if (res) {
                                    this.$parent.interview();
                                    this.closeDialog();
                                    this.$message.success("编辑成功!");
                                }
                            });
                    }
                    // 总结
                    else {
                        let params = {
                            id: this.tableItem.id,
                            status,
                            conclusion: this.editForm.conclusion,
                        };
                        oaApi.interviewUpdateStatus(params,"post").then((res) => {
                            if (res) {
                                this.$parent.interview();
                                this.$emit("update:editVisible", false);
                            }
                        });
                    }
                }
            });
        },
        getRoleList() {
            oaApi.roleSelect({}, "get").then((res) => {
                if (res) {
                    this.roleList = res.data;
                }
            });
        },
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:editVisible", false);
            this.$refs["editForm"].resetFields();
            this.$refs["editForm"].clearValidate();
        },
        fileChange(data) {
            //console.log(data);
            this.editForm.file = data;
            this.$refs["editForm"].clearValidate("file");
        },
        getStaffSelect() {
            oaApi.select({}, "get").then((res) => {
                if (res) {
                    //console.log(res);
                    this.staffList = res.data;
                }
            });
        },
        interview() {
            oaApi.interview({}, "get", this.tableItem.id).then((res) => {
                //console.log(res);
                if (res.code == 200) {
                    for (let key in this.editForm) {
                        this.editForm[key] = res.data[key];
                    }
                    //console.log("this.editForm", this.editForm);
                    this.file = [
                        {
                            name: res.data.file.split("/")[
                                res.data.file.split("/").length - 1
                            ],
                            url: res.data.file,
                        },
                    ];
                    if (this.special) {
                    }
                }
            });
        },
    },
    components: {
        fileUpload,
    },
    computed:{
        ...mapState({
            pickerOptions: (state) => state.index.pickerOptions,
        })
    }
};
</script>

<style lang="scss" scoped>
.edit {
    .el-dialog__body {
        pediting: 20px 40px;
    }
    .el-select,
    .el-date-editor {
        width: 100%;
    }
    .el-form-item {
        .el-form-item__content {
            .el-radio {
                margin: 0;
                width: 100px;
            }
        }
    }
    .container {
        margin-top: 10px;
    }
}
</style>